import { render, staticRenderFns } from "./ms-show-service.vue?vue&type=template&id=fc1c9cc2&scoped=true"
import script from "./ms-show-service.vue?vue&type=script&lang=js"
export * from "./ms-show-service.vue?vue&type=script&lang=js"
import style0 from "./ms-show-service.vue?vue&type=style&index=0&id=fc1c9cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c9cc2",
  null
  
)

export default component.exports